import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

type GraphData = {
  year?: number;
  month?: number;
  name: string;
  value: number;
};

type BarGraphProps = {
  graphData: GraphData[];
  height?: number;
  label: string;
  type: 'line' | 'bar';
};

const BarChart = (props: BarGraphProps) => {
  const { graphData, height, label, type } = props;
  const chartRef = useRef<any>(null);

  useEffect(() => {
    // Data for the chart
    if (graphData?.length) {
      const data = {
        labels: graphData.map((item: GraphData) => item.name),
        datasets: [
          {
            label: label,
            data: graphData.map((item: GraphData) => item.value),
            backgroundColor: [
              'rgba(75, 192, 192, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              'rgba(153, 102, 255, 0.2)',
              'rgba(201, 203, 207, 0.2)',
              'rgba(255, 99, 132, 0.2)',
              'rgba(255, 159, 64, 0.2)',
              'rgba(255, 205, 86, 0.2)',
            ],
            borderColor: [
              'rgb(75, 192, 192)',
              'rgb(54, 162, 235)',
              'rgb(153, 102, 255)',
              'rgb(201, 203, 207)',
              'rgb(255, 99, 132)',
              'rgb(255, 159, 64)',
              'rgb(255, 205, 86)',
            ],
            borderWidth: 1,
          },
        ],
      };

      // Chart configuration options
      const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,

            ticks: {
              precision: 0,
              callback: function (value: any) {
                // Convert the value to K (thousands) and format it
                if (value >= 1000) {
                  return value / 1000 + 'K';
                } else {
                  return value;
                }
              },
            },
          },
        },
      };
      // Create a new chart instance
      const ctx = chartRef.current.getContext('2d');
      const newChart = new Chart(ctx, {
        type: type,
        data: data,
        options: options,
      });

      return () => {
        newChart.destroy();
      };
    }
  }, [graphData]);

  return (
    <div data-testid={'barchart-wrapper'}>
      <canvas
        data-testid={'barchart-canvas'}
        ref={chartRef}
        width={500}
        height={height ? height : 200}
      />
    </div>
  );
};

export default BarChart;
